<ng-container [formGroup]="formGroup" [ngSwitch]="readonly">
  <ng-container *ngSwitchDefault [ngSwitch]="type">
    <!-- DEFAULT INPUT -->
    <input
      *ngSwitchDefault
      class="lxm-input {{ inputClass }}"
      [class.has-left-icon]="icon && iconPosition === 'left'"
      [class.has-right-icon]="icon && iconPosition === 'right'"
      [class.has-clearable-and-right-icon]="clearable && formGroup.get(for).value && icon && iconPosition === 'right'"
      placeholder="{{ placeholder | translate }}"
      [type]="type"
      [formControlName]="for"
      [id]="id"
      [name]="name ?? for"
      [maxlength]="maxlength"
      [attr.disabled]="disabled ? true : undefined"
      [autocomplete]="autocomplete"
      [pattern]="pattern"
      (blur)="blur.emit($event)"
      [tabindex]="tabIndex"
      #input
    />

    <!-- PASSWORD INPUT -->
    <ng-container *ngSwitchCase="'password'">
      <input
        class="lxm-input {{ inputClass }}"
        [class.has-left-icon]="icon && iconPosition === 'left'"
        [class.has-right-icon]="icon && iconPosition === 'right'"
        placeholder="{{ placeholder | translate }}"
        [type]="actualType || type"
        [formControlName]="for"
        [id]="id"
        [name]="name ?? for"
        [maxlength]="maxlength"
        [attr.disabled]="disabled ? true : undefined"
        [autocomplete]="autocomplete"
        [pattern]="pattern"
        (blur)="blur.emit($event)"
        [tabindex]="tabIndex"
        #input
      />
      <div class="input-icon input-icon-right size-lg view-icon" *ngIf="this.formGroup.get(this.for)?.value"
        (pointerdown)="showPassword($event)" (pointerup)="hidePassword($event)"></div>
    </ng-container>

    <!-- PRICE INPUT -->
    <input
      *ngSwitchCase="'price'"
      class="lxm-input {{ inputClass }}"
      [class.has-left-icon]="icon && iconPosition === 'left'"
      [class.has-right-icon]="icon && iconPosition === 'right'"
      [class.has-clearable-and-right-icon]="clearable && formGroup.get(for).value && icon && iconPosition === 'right'"
      placeholder="{{ placeholder | translate }}"
      type="text"
      [formControlName]="for"
      [id]="id"
      [name]="name ?? for"
      [maxlength]="maxlength"
      [autocomplete]="autocomplete"
      [pattern]="pattern"
      [attr.disabled]="disabled ? true : undefined"
      (blur)="blur.emit($event)"
      mask="separator.{{ pricePrecision }}"
      prefix="{{ currencyPrefix }} "
      decimalMarker=","
      [tabindex]="tabIndex"
      #input
    />

    <!-- NUMERIC INPUT -->
    <input
      *ngSwitchCase="'numeric'"
      class="lxm-input {{ inputClass }}"
      [class.has-left-icon]="icon && iconPosition === 'left'"
      [class.has-right-icon]="icon && iconPosition === 'right'"
      [class.has-clearable-and-right-icon]="clearable && formGroup.get(for).value && icon && iconPosition === 'right'"
      placeholder="{{ placeholder | translate }}"
      [formControlName]="for"
      [id]="id"
      [name]="name ?? for"
      type="text"
      [maxlength]="maxlength"
      [autocomplete]="autocomplete"
      [pattern]="pattern"
      [attr.disabled]="disabled ? true : undefined"
      [allowNegativeNumbers]="allowNegativeNumbers"
      (blur)="blur.emit($event)"
      mask="separator.{{ digits }}"
      decimalMarker=","
      [suffix]="suffix"
      [tabindex]="tabIndex"
      #input
    />

    <!-- PERCENT INPUT -->
    <input
      *ngSwitchCase="'percent'"
      class="lxm-input {{ inputClass }}"
      [class.has-left-icon]="icon && iconPosition === 'left'"
      [class.has-right-icon]="icon && iconPosition === 'right'"
      [class.has-clearable-and-right-icon]="clearable && formGroup.get(for).value && icon && iconPosition === 'right'"
      placeholder="{{ placeholder | translate }}"
      [formControlName]="for"
      [id]="id"
      [name]="name ?? for"
      [maxlength]="maxlength"
      type="text"
      [autocomplete]="autocomplete"
      [pattern]="pattern"
      [attr.disabled]="disabled ? true : undefined"
      (blur)="blur.emit($event)"
      mask="separator.{{ digits }}"
      suffix="%"
      decimalMarker=","
      [allowNegativeNumbers]="allowNegativeNumbers"
      [tabindex]="tabIndex"
      #input
    />
    
    <ng-container *ngSwitchCase="'url'">
      <span class="url-prefix">https://</span>
      <input
        placeholder="{{ placeholder | translate }}"
        class="lxm-input {{ inputClass }}"
        [type]="type"
        [formControlName]="for"
        [id]="id"
        [name]="name ?? for"
        [maxlength]="maxlength"
        [attr.disabled]="disabled ? true : undefined"
        [autocomplete]="autocomplete"
        [pattern]="pattern"
        (blur)="blur.emit($event)"
        [tabindex]="tabIndex"
        #input
      />
    </ng-container>

    <!-- ICONS (SHARED FOR ALL INPUT TYPES) -->
    <svg-icon
      *ngIf="icon && iconPosition === 'left'"
      [key]="icon"
      class="input-icon input-icon-left"
      fontSize="14px"
    ></svg-icon>
    
    <!-- Clearable icon - positioned based on whether there's a right icon -->
    <svg-icon
      *ngIf="clearable && formGroup.get(for).value"
      key="x"
      [class]="'input-icon !size-[0.708em] generic-hover ' + (icon && iconPosition === 'right' ? 'input-icon-clearable' : 'input-icon-right')"
      fontSize="14px"
      (click)="clear()"
    ></svg-icon>
    
    <svg-icon
      *ngIf="icon && iconPosition === 'right'"
      [key]="icon"
      class="input-icon input-icon-right"
      fontSize="14px"
    ></svg-icon>
  </ng-container>

  <ng-container *ngSwitchCase="true">
    <span class="lxm-input input-readonly w-full" [ngClass]="inputClass">
      {{ inputValue ?? '-' }}
    </span>
  </ng-container>

  <ng-content></ng-content>
</ng-container>
